import { useEffect, useState } from "react";
import { useMediaQuery, useTheme } from '@mui/material';

export function usePWAInstall() {
    const theme = useTheme();
    const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isInstallable, setIsInstallable] = useState(false);
    const isMobileDevice = /Android|iPhone|iPad|iPod|webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent);
    useEffect(() => {
        if (!isMobileDevice && !isMobileScreen) return;
        let handlerCalled = false;
        const handler = (e) => {
            if (handlerCalled) return; 
            handlerCalled = true;
            e.preventDefault();
            setDeferredPrompt(e);
            setIsInstallable(true);
        };
        window.addEventListener("beforeinstallprompt", handler);
        return () => window.removeEventListener("beforeinstallprompt", handler);
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        console.log(outcome === "accepted" ? "App instalada ✅" : "Instalación cancelada ❌");
        setDeferredPrompt(null);
        setIsInstallable(false);
    };

    return { isInstallable, handleInstallClick, isMobileDevice, isMobileScreen };
}
